import { render, staticRenderFns } from "./CandidateReport.vue?vue&type=template&id=73ed764e&scoped=true"
import script from "./CandidateReport.vue?vue&type=script&lang=ts"
export * from "./CandidateReport.vue?vue&type=script&lang=ts"
import style0 from "./CandidateReport.vue?vue&type=style&index=0&id=73ed764e&prod&lang=scss&scoped=true"
import style1 from "./CandidateReport.vue?vue&type=style&index=1&id=73ed764e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed764e",
  null
  
)

export default component.exports